<div class="mzic-avatar-md-mekari">
  <mat-spinner *ngIf="isLoading()" diameter="24" />
  <img
    onerror="this.onerror=null;this.src='assets/images/mocks/TemplateUser4ProfilePicture.png'"
    [alt]="altImage"
    [src]="imageUri"
    (load)="onLoading()"
    [ngStyle]="isLoading() ? { display: 'none' } : { display: 'block' }" />
</div>
